

import { createReducer, on } from '@ngrx/store';
import { SetQrEventState } from '../../models/qr/validate-qr';
import * as qrActions from './qr.actions';

export const qrEventKey = 'qrEvent';

export const initialState: SetQrEventState = {
    accessEvent: undefined,
    isLoading: false,
    isLoaded: false,
    correctAccess: false,
    incorrectAccess: false,
    responseMessage: ''
};

export const qrEventReducer = createReducer(
    initialState,
    on(qrActions.validateQRAccessSuccess, (state, response) => ({
        ...state,
        accessEvent: response.validateBooked,
        isLoading: false,
        isLoaded: true,
        incorrectAccess: false,
        correctAccess: true,
        responseMessage: ''
    })),
    on(qrActions.validateQRAccessError, (state, response) => ({
        ...state,
        isLoading: false,
        isLoaded: true,
        incorrectAccess: true,
        correctAccess: false,
        responseCode: response.errorCode,
        responseMessage: response.responseMessage
    }))
);
